"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.array.map");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  enable-background: new 0 0 500 500;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Svg = styled_components_1["default"].svg(_templateObject());

var reduceToPrimary = function reduceToPrimary(children) {
  if (typeof children === "undefined") return children;
  return react_1["default"].Children.map(children, function (child) {
    var clonedChild = react_1["default"].cloneElement(child, {
      children: child.props.children && reduceToPrimary(child.props.children) || undefined,
      fill: child.props.fill === "currentColor" && "url(#primaryFill)" || undefined,
      stroke: child.props.stoke === "currentColor" && "url(#primaryFill)" || undefined
    });
    return clonedChild;
  });
};

exports["default"] = function (props) {
  var _props$primary = props.primary,
      primary = _props$primary === void 0 ? false : _props$primary,
      children = props.children,
      size = props.size,
      rest = __rest(props, ["primary", "children", "size"]);

  var updatedChildren = primary ? reduceToPrimary(children) : children;
  return react_1["default"].createElement(Svg, Object.assign({
    "aria-hidden": "true",
    focusable: "false",
    role: "img",
    height: size,
    width: size,
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), primary && react_1["default"].createElement("defs", null, react_1["default"].createElement("pattern", {
    id: "primaryFill",
    patternUnits: "userSpaceOnUse",
    width: "100%",
    height: "100%"
  }, react_1["default"].createElement("image", {
    href: "https://menu.cdn.bitcoindotcom.net/uni/dist/assets/images/fill.png",
    x: "0",
    y: "0",
    width: "100%",
    height: "100%"
  }))), updatedChildren);
};